import { render, staticRenderFns } from "./master_kelompok.vue?vue&type=template&id=fa1fef0e&"
import script from "./master_kelompok.vue?vue&type=script&lang=js&"
export * from "./master_kelompok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports